import Vue from 'vue'
import Vuex from 'vuex'
import incidents from './modules/incidents'
import rules from './modules/rules'
import commonStates from './modules/common'
import analysis from './modules/analysis';
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        incidents, rules, commonStates, analysis
    }
})
